import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {IColumnData, IRowData, tableShipmentsLimit} from "../../constants/Table/interfaces";

interface IStocksReducer {
    rowData: IRowData[];
    columnData: IColumnData[];
    currentPage: number;
    currentLimit: tableShipmentsLimit;
    isNeedUpdateData: boolean;
    idFilter: number|null;
    skuFilter: string|null;
    barcodeFilter: string|null;
    sizeFilter: string|null;
    nameFilter: string|null;
    brandFilter: string|null;
    notesFilter: string|null;
}

const initialState: IStocksReducer = {
    rowData: [],
    columnData: [],
    currentPage: 1,
    currentLimit: 10,
    isNeedUpdateData: false,
    idFilter: null,
    skuFilter: null,
    barcodeFilter: null,
    sizeFilter: null,
    nameFilter: null,
    brandFilter: null,
    notesFilter: null,
}

const stocksStateSlice = createSlice({
    name: 'stocksFBO',
    initialState,
    reducers: {
        /**
         * @description Removing one element from rowData
         * @param state
         * @param action
         */
        removeRowDataElement(state, action: PayloadAction<{ id: string }>) {
            state.rowData = state.rowData.filter(
                (element) => element.id !== action.payload.id
            );
        },
        /**
         * @description Editing one element in rowData
         * @param state
         * @param action
         */
        editRowDataElement(state, action: PayloadAction<IRowData>) {
            state.rowData = state.rowData.map((element) =>
                element.id !== action.payload.id ? element : action.payload
            );
        },
        /**
         * @description Setting rows
         * @param state
         * @param action
         */
        setRowData(state, action: PayloadAction<IRowData[]>) {
            state.rowData = action.payload;
        },
        /**
         * @description Set current pagination page
         * @param state
         * @param action
         */
        setCurrentPage(state, action: PayloadAction<number>) {
            state.currentPage = action.payload;
        },
        /**
         * @description Set current pagination limit of elements at page
         * @param state
         * @param action
         */
        setCurrentLimit(state, action: PayloadAction<tableShipmentsLimit>) {
            state.currentLimit = action.payload;
        },
        /**
         * @description Set flag that means is data must be updated
         * @param state
         * @param action
         */
        setIsNeedUpdateData(state, action: PayloadAction<boolean>) {
            state.isNeedUpdateData = action.payload;
        },
        setIdFilter(state, action: PayloadAction<number>) {
            state.idFilter = action.payload;
        },
        setSkuFilter(state, action: PayloadAction<string>) {
            state.skuFilter = action.payload;
        },
        setBarcodeFilter(state, action: PayloadAction<string>) {
            state.barcodeFilter = action.payload;
        },
        setSizeFilter(state, action: PayloadAction<string>) {
            state.sizeFilter = action.payload;
        },
        setNameFilter(state, action: PayloadAction<string>) {
            state.nameFilter = action.payload;
        },
        setBrandFilter(state, action: PayloadAction<string>) {
            state.brandFilter = action.payload;
        },
        setNotesFilter(state, action: PayloadAction<string>) {
            state.notesFilter = action.payload;
        },
    },
});

const stocks = stocksStateSlice.reducer;

export const {
    removeRowDataElement,
    editRowDataElement,
    setIsNeedUpdateData,
    setRowData,
    setIdFilter,
    setSkuFilter,
    setBarcodeFilter,
    setSizeFilter,
    setNameFilter,
    setBrandFilter,
    setNotesFilter,
} = stocksStateSlice.actions;

export default stocks